var _line, _line2, _line3, _line4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdgeBundling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31.4814,
    y1: 5.07458,
    x2: 31.4814,
    y2: 57.8509,
    stroke: "#B3B3B3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55.9893,
    y1: 30.9479,
    x2: 3.97218,
    y2: 30.9479,
    stroke: "#B3B3B3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 52.4166,
    y2: -0.5,
    transform: "matrix(-0.684349 -0.729155 0.719175 -0.694829 49.9873 49.7317)",
    stroke: "#B3B3B3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 52.3981,
    y2: -0.5,
    transform: "matrix(-0.701965 0.712211 -0.701966 -0.712211 49.9873 11.9623)",
    stroke: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8773 48.5835C42.0299 42.7946 32.8778 27.3818 51.0487 12.042",
    stroke: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9814 55.821C30.8143 46.8558 34.3822 29.2299 57.9899 30.4478",
    stroke: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8782 49.3408C19.3011 42.1642 34.1081 32.2604 49.9525 50.0585",
    stroke: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24425 26.6944C4.58816 24.3162 8.3884 24.3162 10.7323 26.6944C13.0762 29.0725 13.0762 32.9282 10.7323 35.3063C8.3884 37.6845 4.58816 37.6845 2.24425 35.3063C-0.0996698 32.9282 -0.0996696 29.0725 2.24425 26.6944Z",
    fill: "#8CBFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7401 2.30594C33.3962 -0.0721837 29.596 -0.0721819 27.2521 2.30594C24.9081 4.68407 24.9081 8.53977 27.2521 10.9179C29.596 13.296 33.3962 13.296 35.7401 10.9179C38.084 8.53977 38.084 4.68407 35.7401 2.30594Z",
    fill: "#3B82C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7489 26.6645C58.405 24.2863 54.6048 24.2863 52.2608 26.6645C49.9169 29.0426 49.9169 32.8983 52.2608 35.2764C54.6048 37.6545 58.405 37.6545 60.7489 35.2764C63.0928 32.8983 63.0928 29.0426 60.7489 26.6645Z",
    fill: "#2B6299"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7401 52.0376C33.3962 49.6595 29.596 49.6595 27.2521 52.0376C24.9081 54.4158 24.9081 58.2715 27.2521 60.6496C29.596 63.0277 33.3962 63.0277 35.7401 60.6496C38.084 58.2715 38.084 54.4158 35.7401 52.0376Z",
    fill: "#3B82C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.746 9.41043C50.4021 7.03231 46.6018 7.03231 44.2579 9.41044C41.914 11.7886 41.914 15.6443 44.2579 18.0224C46.6018 20.4005 50.4021 20.4005 52.746 18.0224C55.0899 15.6443 55.0899 11.7886 52.746 9.41043Z",
    fill: "#3B82C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2462 8.39554C12.5901 6.01742 16.3904 6.01742 18.7343 8.39554C21.0782 10.7737 21.0782 14.6294 18.7343 17.0075C16.3904 19.3856 12.5901 19.3856 10.2462 17.0075C7.90228 14.6294 7.90228 10.7737 10.2462 8.39554Z",
    fill: "#8CBFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2462 44.9331C12.5901 42.555 16.3904 42.555 18.7343 44.9331C21.0782 47.3113 21.0782 51.167 18.7343 53.5451C16.3904 55.9232 12.5901 55.9232 10.2462 53.5451C7.90228 51.167 7.90228 47.3113 10.2462 44.9331Z",
    fill: "#3B82C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.746 44.9331C50.4021 42.555 46.6018 42.555 44.2579 44.9331C41.914 47.3113 41.914 51.167 44.2579 53.5451C46.6018 55.9232 50.4021 55.9232 52.746 53.5451C55.0899 51.167 55.0899 47.3113 52.746 44.9331Z",
    fill: "#2B6299"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBundling);
export default __webpack_public_path__ + "static/media/edge_bundling.eb9d3ac4.svg";
export { ForwardRef as ReactComponent };